// src/components/ConfirmModal.jsx
import React from "react";

export default function ConfirmModal({
  isOpen,
  title,
  message,
  onConfirm,
  onCancel,
  /** optional overrides ↓ */
  confirmText = "Confirm",
  cancelText  = "Cancel",
  hideCancel  = false,
  confirmDisabled = false, // NEW
}) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black/60 flex items-center justify-center">
      <div className="bg-card border border-border shadow-xl rounded-xl max-w-md w-full p-6">
        {/* ── Header ──────────────────────────────── */}
        <h3 className="text-lg font-semibold text-white mb-4 text-center">
          {title}
        </h3>

        {/* ── Body ────────────────────────────────── */}
        <div className="text-white mb-6 space-y-4 text-center leading-relaxed">
          {message}
        </div>

        {/* ── Footer / Buttons ────────────────────── */}
        <div className="flex justify-center gap-4">
          {!hideCancel && (
            <button
              onClick={onCancel}
              disabled={false} // keep cancel available even while saving
              className="bg-zinc-700 text-white px-4 py-2 rounded-lg hover:bg-zinc-600 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {cancelText}
            </button>
          )}

          <button
            onClick={onConfirm}
            disabled={confirmDisabled}
            className="bg-orange-500 hover:bg-orange-600 active:bg-orange-700 text-white font-semibold px-4 py-2 rounded-lg transition disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}
